import { takeLatest, put, call, select } from "redux-saga/effects";
import { IObservationService, TGetObservationPageValue } from "../../services/observationService";
import { IRequestFetchObservationList, requestObservationList, createSuccessFetchObservationListAction, createFailureFetchObservationListAction } from "../actions/observationListActions";
import { createAppendToPersonList } from "../actions/personAction";
import { selectObservationFilters } from "../selectors/observationListSelectors";
import { IObservationFilters } from "../reducers/observationListReducer";

const makeFetchObservationListSaga = (observationService: IObservationService) =>
    function* saga(action: IRequestFetchObservationList) {
        const filters: IObservationFilters = yield select(selectObservationFilters);

        const result: TGetObservationPageValue = yield call(
            observationService.getObservations,
            action.payload.search,
        );

        if (result.isFailure === true) {
            yield put(createFailureFetchObservationListAction(result.error));
            return
        }
        if (result.value.context.persons) {
            yield put(createAppendToPersonList(result.value.context.persons));
        }

        yield put(createSuccessFetchObservationListAction(result.value.observations));
    };

export default function create(observationService: IObservationService) {
    return takeLatest(requestObservationList, makeFetchObservationListSaga(observationService));
}
